import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Skill } from './skill';

export interface ToolsCollection {
  getTools(): Observable<Skill[]>;
  addTool(tool: Skill): Promise<unknown>;
  editTool(tool: Skill): Promise<void>;
  deleteTool(tool: Skill): Promise<void>;
}

export const TOOLS_COLLECTION = new InjectionToken<ToolsCollection>(
  'TOOLS_COLLECTION',
);
